import type { ResetPassword } from 'models';
import { useMutation } from 'query';
import { resetPassword } from '../../services';

export const useResetPasswordMutation = () =>
  useMutation<unknown, ResetPassword>({ mutationFn: async (data: ResetPassword) => resetPassword(data) });
